import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useMenu } from 'components/ds'
import type { Track } from 'types/track'

type Props = {
  closeMenu: () => void
  track: Track
}

const LyricTranscription = ({ track }: Props): React.ReactNode => {
  const Menu = useMenu()
  const navigate = useNavigate()
  return (
    <Menu.Item
      onSelect={() =>
        navigate({
          pathname: `/explorer/tracks/${track.id}/edit-metadata/`,
          search: '?tab=1',
        })
      }
    >
      Lyric transcription
    </Menu.Item>
  )
}

export default LyricTranscription
